import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

import { breakpoints } from '@shared/constants';

export const OptionWrapper = styled.button(
    ({ theme: { palette } }) => css`
        align-items: center;
        background-color: initial;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        outline: none;
        padding: 0;
        position: relative;
        width: 100%;

        & ~ & {
            margin-top: 16px;
        }

        &:hover ${ActionIcon} {
            transform: translate(5px, -50%);

            path {
                stroke: ${palette.text.primary};
            }
        }

        @media (max-width: ${breakpoints.xs}px) {
            align-items: flex-start;
            flex-direction: column;
        }
    `,
);

export const OptionNameWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const OptionName = styled(Typography.TextBody_16_24)`
    white-space: nowrap;
`;

export const OptionIcon = styled(IconManager)`
    margin-right: 12px;
`;

export const ActionIcon = styled(IconManager)(
    ({ theme: { transition } }) => css`
        cursor: default;
        position: absolute;
        right: -12px;
        top: 50%;
        transform: translateY(-50%);
        transition: all ${transition.fast}s;
    `,
);

export const ActionName = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const ActionNameWrapper = styled.div(
    ({ theme: { palette } }) => css`
        color: ${palette.text.primary};
        margin: 0 20px 0 10px;
        min-width: 50px;

        @media (max-width: ${breakpoints.xs}px) {
            color: ${palette.text.secondary};
            margin-left: 36px;
        }
    `,
);
